const contentRecycleBin = ()=>import("./views/contentRecycleBin.vue");

export default {
  // 内容回收站
  path: "/contentRecycleBin",
  name: "contentRecycleBin",
  component: contentRecycleBin,
  meta: {
    root: "/inforMan"
  }
}



// WEBPACK FOOTER //
// ./src/core/modules/contentRecycleBin/router.js